import { api } from '@/lib/axios';
import type { ApiResponse } from '@/types/api';
import type { Me, TokenResponse } from '@/types/domain';

/** Exchange a Firebase idToken for our own access token (+ refresh cookie). */
export async function loginWithFirebase(idToken: string): Promise<TokenResponse> {
  const res = await api.post<ApiResponse<TokenResponse>>('/auth/firebase', {
    id_token: idToken,
  });
  return res.data.data;
}

export async function fetchMe(): Promise<Me> {
  const res = await api.get<ApiResponse<Me>>('/auth/me');
  return res.data.data;
}

export async function logout(): Promise<void> {
  await api.post('/auth/logout');
}
